import { cn } from '@/lib/utils';
import { Image } from 'expo-image';
import * as React from 'react';
import { View } from 'react-native';

const STAFF_BADGE_MARK = require('@/assets/images/icon.png');

export function StaffBadge({
  className,
}: {
  className?: string;
}) {
  return (
    <View
      className={cn(
        'size-3.5 shrink-0 self-center items-center justify-center overflow-hidden',
        className
      )}>
      <Image
        source={STAFF_BADGE_MARK}
        cachePolicy="memory-disk"
        style={{ width: '100%', height: '100%', maxWidth: '100%', maxHeight: '100%' }}
        contentFit="contain"
      />
    </View>
  );
}
